var BlockView = require('views/block/base-block-view');
const AhoyService = require('services/ahoy-service');
import IconLoadService from 'services/icon-load-service';
import utils from 'lib/utils';
import { KeybindingService, keys } from 'services/keybinding-service';
const { Escape } = keys;

var ModalView = BlockView.extend({
  initialize: function() {
    BlockView.prototype.initialize.apply(this, arguments);
    var customHeader = this.model.get('custom_header');
    var customization = EF.customizations.getByKeyAndSlug('text-content-customization', customHeader);
    if(customization) {
      this.model.set('header', customization.custom_text);
    }
    IconLoadService.applyIcon('fal fa-times', this.model.get('cid'), 'fa-lg');
    utils.setHeadingLevel(this.model, this.model.get('heading_level'), 'div');
  },
  hideOnKeydownHandler: null,
  load: function() {
    if(this.model.get('blocks')) {
      this.renderNestedBlocks(this.model.get('cid') + '-modal-blocks', this.model.get('blocks'));
    }

    this.modal = $('#' + this.model.get('id'));
    this.prevElement = document.activeElement;
    this.modal.focus();
    if(this.model.get('auto_open') !== false) {
      this.modal.modal('show');
    }
    this.modal.on('hidden.bs.modal', (e) => {
      if($(e.target).attr('id') === this.model.get('id')) {
        AhoyService.track('modal', {action: 'hidden', id: this.model.get('id')});
        this.trigger('hidden', e);
        if(!this.model.get('complete_on_shown')) {
          this.readyToGo();
        }
      Chaplin.mediator.publish('action:pause');
      }
      $(document).off('keydown', this.hideOnKeydownHandler);
    });
    this.modal.on('shown.bs.modal', (e) => {
      if($(e.target).attr('id') === this.model.get('id')) {
        AhoyService.track('modal', {action: 'shown', id: this.model.get('id')});
        this.trigger('shown', e);
      }
      $(document).on(
        'keydown',
        (this.hideOnKeydownHandler = e => {
          KeybindingService.with(e).bind(Escape, () => {
            this.hide();
            e.preventDefault();
            e.stopImmediatePropagation();
          });
        })
      )
    });
    AhoyService.track('modal', {action: 'loaded', id: this.model.get('id')});
  },
  hide: function() {
    this.modal.modal('hide');
  },
  play: function() {
    if(this.model.get('complete_on_shown')) {
      this.readyToGo();
    } else if(this.model.get('blocks')) {
      this.$('[data-close]').attr('disabled', true);
      var nestedBlocksView = this.subviewsByName[this.model.get('cid') + '-modal-blocks'];
      this.listenTo(nestedBlocksView, 'block:state:completed', () => {
        if(nestedBlocksView.isComplete()) {
          AhoyService.track('modal', {action: 'completed', id: this.model.get('id')});
          this.readyToGo();
          if(this.$el) {
            this.$('[data-close]').attr('disabled', false);
          }
          if(this.model && this.model.get('close_on_complete')) {
            this.modal.modal('hide');
          }
          this.readyToGo();
        }
      });
    }
  },
  dispose: function() {
    this.modal.modal('hide');
    this.modal.off('hidden.bs.modal');
    this.modal.off('shown.bs.modal');
    if(this.prevElement) {
      this.prevElement.focus();
    }
    $('.modal-open').removeClass('modal-open');
    $('.modal-backdrop').remove();
    BlockView.prototype.dispose.apply(this, arguments);
  }
});

module.exports = ModalView;
